import { render } from "./orgRiskMaster.vue?vue&type=template&id=4ea4794e&scoped=true&ts=true"
import script from "./orgRiskMaster.vue?vue&type=script&lang=ts"
export * from "./orgRiskMaster.vue?vue&type=script&lang=ts"

import "./orgRiskMaster.vue?vue&type=style&index=0&id=4ea4794e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea4794e"]])

export default __exports__